import React from "react";
import { Col, Card, CardBody, CardHeader, Button, Badge } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import SubOperationsList from "./SubOperationsList";
import SubOperationBuildForm from "./SubOperationBuildForm";
import SubOperationSearchForm from "./SubOperationSearchForm";
import ModalConfirmacao from "./ModalConfirmacao";

// AIDEV-NOTE: Sub-operations panel component (Col-4) with view mode management
// AIDEV-NOTE: ModalFornecedor removed - now rendered in index.js outside main form
const SubOperationsPanel = ({
  // Sub-operations states
  subOperacoes,
  viewMode,
  setViewMode,
  setSubOperacoes,

  // Current selected data
  cliente,
  moeda,
  direcao,

  // Data lists
  listaFornecedores,
  listaClientes,

  // Build form states
  buildFormData,
  handleBuildFormChange,
  handleBuildSubOperation,

  // Search states
  searchTerm,
  setSearchTerm,
  availableSubOps,
  selectedSubOps,
  loadingSubOps,
  currentPage,
  totalPages,
  setCurrentPage,
  handleSelectSubOperation,
  handleAddSelectedSubOperations,
  fetchAvailableSubOps,

  // Modal states
  modalFornecedor,
  setModalFornecedor,
  onFornecedorAdded,

  // Modal confirmation states
  modalConfirmacao,
  toggleModalConfirmacao,
  handleConfirmLimparSubOperacoes,
  novaDirecao,
  novaMoeda,
  tipoMudanca,
}) => {
  // AIDEV-NOTE: Validation to enable/disable sub-operation buttons
  const canAddSubOperations = cliente && direcao && moeda?.data?.moeda;

  return (
    <>
      <ModalConfirmacao
        isOpen={modalConfirmacao}
        toggle={toggleModalConfirmacao}
        onConfirm={handleConfirmLimparSubOperacoes}
        titulo={
          tipoMudanca === "direcao" ? "Mudança de Direção" : "Mudança de Moeda"
        }
        mensagem={
          tipoMudanca === "direcao"
            ? `Você está alterando a direção da operação. Isso removerá todas as sub-operações já adicionadas. Deseja continuar?`
            : `Você está alterando a moeda da operação. Isso removerá todas as sub-operações já adicionadas. Deseja continuar?`
        }
        textoBotaoConfirmar="Sim, Limpar Sub-operações"
        textoBotaoCancelar="Cancelar"
        corBotaoConfirmar="warning"
        icone="alert-triangle"
      />

      <Col lg={4}>
        <Card>
          <CardHeader className="d-flex align-items-center border-0">
            <h5 className="card-title mb-0 flex-grow-1">
              Sub-operações
              {subOperacoes.length > 0 && (
                <Badge color="primary" className="ms-2">
                  {subOperacoes.length}
                </Badge>
              )}
            </h5>

            {/* Botões de navegação baseados no modo atual */}
            {viewMode === "list" && (
              <div className="d-flex gap-1">
                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => setViewMode("add")}
                  disabled={!canAddSubOperations}
                  title={
                    !canAddSubOperations
                      ? "Selecione Cliente, Direção e Moeda primeiro"
                      : "Buscar sub-operações existentes"
                  }
                >
                  <FeatherIcon icon="search" className="me-1" size={14} />
                  Buscar
                </Button>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setViewMode("build")}
                  disabled={!canAddSubOperations}
                  title={
                    !canAddSubOperations
                      ? "Selecione Cliente, Direção e Moeda primeiro"
                      : "Construir nova sub-operação"
                  }
                >
                  <FeatherIcon icon="plus" className="me-1" size={14} />
                  Nova
                </Button>
              </div>
            )}

            {viewMode !== "list" && (
              <Button
                color="secondary"
                size="sm"
                onClick={() => setViewMode("list")}
              >
                <FeatherIcon icon="arrow-left" className="me-1" size={14} />
                Voltar
              </Button>
            )}
          </CardHeader>

          <CardBody>
            {/* Renderizar componente baseado no modo de visualização */}
            {viewMode === "list" && (
              <SubOperationsList
                subOperacoes={subOperacoes}
                setSubOperacoes={setSubOperacoes}
                moeda={moeda}
                direcao={direcao}
                cliente={cliente}
                setViewMode={setViewMode}
              />
            )}

            {viewMode === "build" && (
              <SubOperationBuildForm
                buildFormData={buildFormData}
                handleBuildFormChange={handleBuildFormChange}
                handleBuildSubOperation={handleBuildSubOperation}
                listaFornecedores={listaFornecedores}
                moeda={moeda}
                direcao={direcao}
                setViewMode={setViewMode}
                setModalFornecedor={setModalFornecedor}
              />
            )}

            {viewMode === "add" && (
              <SubOperationSearchForm
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                availableSubOps={availableSubOps}
                selectedSubOps={selectedSubOps}
                loadingSubOps={loadingSubOps}
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
                moeda={moeda}
                handleSelectSubOperation={handleSelectSubOperation}
                handleAddSelectedSubOperations={handleAddSelectedSubOperations}
                fetchAvailableSubOps={fetchAvailableSubOps}
                setViewMode={setViewMode}
              />
            )}
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default SubOperationsPanel;
